import React, { useEffect, useCallback } from 'react'
import { Box, HStack, Text, Badge, Button } from '@chakra-ui/react'
import { WarningIcon } from '@chakra-ui/icons'
import useImpersonationSession from '../hooks/useImpersonationSession'
import { stopImpersonation } from '../utils/impersonationService'

interface ImpersonationBannerProps {}

const formatCountdown = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

const ImpersonationBanner: React.FC<ImpersonationBannerProps> = () => {
  const session = useImpersonationSession()

  const handleStop = useCallback(() => {
    void stopImpersonation('explicit')
  }, [])

  useEffect(() => {
    if (session.isImpersonating && session.isExpired) {
      window.dispatchEvent(new CustomEvent('impersonation:expired'))
      window.alert(
        'This impersonation session has expired. Any unsaved form input was not submitted.',
      )
      void stopImpersonation('timeout')
    }
  }, [session.isImpersonating, session.isExpired])

  if (!session.isImpersonating) return null

  return (
    <Box bg='orange.100' w='100%' py={2} px={4}>
      <HStack spacing={4} justify='center'>
        <WarningIcon color='orange.500' />
        <Text fontWeight='medium'>
          {session.impersonatorName} is acting as {session.targetName}
        </Text>
        <Badge colorScheme='orange' fontSize='sm'>
          {formatCountdown(session.remainingMs)}
        </Badge>
        <Button size='sm' colorScheme='orange' onClick={handleStop}>
          Stop Impersonation
        </Button>
      </HStack>
    </Box>
  )
}

export default ImpersonationBanner
